/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { VideoIcon } from '@coursera/cds-icons';

import LoadingSpinner from 'bundles/coursera-ui/components/basic/LoadingSpinner';

export type Props = {
  src?: string;
  alt?: string;
};

const styles = {
  thumbnailDiv: () => css`
    margin: var(--cds-spacing-300) 0;
    position: relative;
    display: flex;
    justify-content: center;
  `,
  thumbnailImg: css`
    width: 100%;
  `,
  videoIcon: css`
    position: absolute;
    align-self: center;
  `,
};

const VideoThumbnail: React.FC<Props> = ({ src, alt }) => {
  return (
    <div css={styles.thumbnailDiv} data-testid="video-thumbnail">
      {src ? (
        <>
          <img css={styles.thumbnailImg} src={src} alt={alt} />
          <VideoIcon color="invert" size="large" css={styles.videoIcon} />
        </>
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
};

export default VideoThumbnail;
